import { ProductType } from "@/types/content/product";
import { ProductThemeType } from "@/types/content/product_theme";

export function getDisplayedProducts(products: ProductType[]): ProductType[] {
    return products.filter(product => product.is_displayed);
}

export function getCatalogDefaultProduct(productTheme: ProductThemeType): ProductType | null {
    const displayedProducts = getDisplayedProducts(productTheme.products);
    const defaultProduct = productTheme.default_product;

    if (defaultProduct?.is_displayed) {
        return defaultProduct;
    }

    return displayedProducts[0] ?? null;
}
